import { CloseIcon, SearchIcon } from '@shared/ui/icons';
import { FC } from 'react';
import { twMerge } from '@shared/utils/twMerge';

type SearchSuffixProps = {
  action: () => void;
  disabled?: boolean;
};
export const SearchSuffix: FC<SearchSuffixProps> = ({ action, disabled }) => {
  return (
    <div
      className={twMerge('p-.5 hover:bg-waterLight cursor-pointer rounded', disabled && 'pointer-events-none')}
      onClick={action}
    >
      {disabled ? <SearchIcon /> : <CloseIcon width={20} height={20} />}
    </div>
  );
};
